import React from 'react'
import {Icon} from '@chakra-ui/react'

const HideIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M12.0374 17.3163C9.12322 17.3163 6.74805 14.9467 6.74805 12.0269C6.74805 9.10706 9.11761 6.7375 12.0374 6.7375C14.9573 6.7375 17.3268 9.10706 17.3268 12.0269C17.3268 14.9467 14.9573 17.3163 12.0374 17.3163ZM12.0374 7.86052C9.74088 7.86052 7.87106 9.73034 7.87106 12.0269C7.87106 14.3235 9.74088 16.1933 12.0374 16.1933C14.334 16.1933 16.2038 14.3235 16.2038 12.0269C16.2038 9.73034 14.334 7.86052 12.0374 7.86052Z"
                fill="currentColor"
            />
            <path
                d="M11.8696 19.1917C5.7042 19.1917 1.06615 12.6502 0.869626 12.3694C0.79663 12.2684 0.768555 12.1504 0.768555 12.0381C0.768555 11.9202 0.802245 11.8023 0.875241 11.7012C1.07177 11.4205 5.81651 4.88454 12.038 4.88454C18.9052 4.88454 22.8919 11.4654 23.0604 11.7405C23.1109 11.8248 23.139 11.9258 23.139 12.0269C23.139 12.128 23.1109 12.2571 23.0548 12.347C22.8807 12.6277 18.6919 19.1917 11.8752 19.1917H11.8696ZM2.02633 12.0438C3.0202 13.324 7.02375 18.0743 11.8696 18.0743C17.2993 18.0743 21.0446 13.2566 21.9093 12.0325C21.0783 10.8028 17.4902 6.00755 12.038 6.00755C7.13043 6.00755 3.03704 10.7691 2.02633 12.0438Z"
                fill="currentColor"
            />
            <path
                d="M22.8413 23.4423C22.6953 23.4423 22.555 23.3862 22.4427 23.2795L0.762874 1.56041C0.543886 1.34142 0.543886 0.987675 0.762874 0.768687C0.981861 0.549699 1.33561 0.549699 1.5546 0.768687L23.2344 22.4878C23.4534 22.7068 23.4534 23.0605 23.2344 23.2795C23.1221 23.3862 22.9817 23.4423 22.8357 23.4423H22.8413Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default HideIcon
